/* MIKOO: an endless strip of cards (homepage "ready gallery walls"): after the last card comes the first again,
   in both directions, edge to edge with no gaps.
   How: the cards are copied once before and once after the real ones. The strip starts on the real ones, and
   when scrolling stops inside a copy it jumps (invisibly, the copy looks the same) by one full set back to the
   real ones. Copies are clickable but hidden from screen readers and skipped by the keyboard (they were inert
   until 2026-10-23: a click on a copy did nothing).
   Turned on by data-mk-loop on a <slider-component>. Dawn's arrows keep working (enableSliderLooping keeps
   them from being disabled at the ends). */
(function () {
  function sign(slider) {
    return getComputedStyle(slider).direction === 'rtl' ? -1 : 1;
  }

  function copy(item) {
    var clone = item.cloneNode(true);
    clone.removeAttribute('id');
    clone.setAttribute('aria-hidden', 'true');
    clone.classList.add('mk-loop-copy');
    /* copies stay clickable (a shopper sees them like any card), only keyboard focus skips them */
    clone.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach(function (el) {
      el.setAttribute('tabindex', '-1');
    });
    /* Dawn's scroll reveal only watches elements present at load: a copy would stay invisible */
    [clone].concat(Array.prototype.slice.call(clone.querySelectorAll('.scroll-trigger'))).forEach(function (el) {
      el.classList.remove('scroll-trigger', 'scroll-trigger--offscreen', 'animate--slide-in', 'animate--fade-in');
    });
    clone.querySelectorAll('[id]').forEach(function (el) { el.removeAttribute('id'); });
    return clone;
  }

  function setup(component) {
    var slider = component.querySelector('[id^="Slider-"]');
    if (!slider || slider.dataset.mkLoopReady) return;
    var items = Array.prototype.slice.call(slider.querySelectorAll(':scope > [id^="Slide-"]'));
    if (items.length < 3) return;
    slider.dataset.mkLoopReady = '1';

    var before = document.createDocumentFragment();
    var after = document.createDocumentFragment();
    items.forEach(function (item) {
      before.appendChild(copy(item));
      after.appendChild(copy(item));
    });
    slider.insertBefore(before, items[0]);
    slider.appendChild(after);

    component.enableSliderLooping = true;
    component.prevButton && component.prevButton.removeAttribute('disabled');
    component.nextButton && component.nextButton.removeAttribute('disabled');

    /* width of one full set, measured between the first copy and the first real card */
    function setWidth() {
      return Math.abs(items[0].offsetLeft - slider.children[0].offsetLeft);
    }

    function jumpTo(position) {
      var behavior = slider.style.scrollBehavior;
      var snap = slider.style.scrollSnapType;
      slider.style.scrollBehavior = 'auto';
      slider.style.scrollSnapType = 'none';
      slider.scrollLeft = position;
      requestAnimationFrame(function () {
        slider.style.scrollBehavior = behavior;
        slider.style.scrollSnapType = snap;
      });
    }

    /* keep the view inside the real set: one set width W from the start */
    function recentre() {
      var w = setWidth();
      if (!w) return;
      var s = sign(slider);
      var p = slider.scrollLeft * s;
      if (p < w * 0.5) jumpTo((p + w) * s);
      else if (p > w * 1.5) jumpTo((p - w) * s);
    }

    jumpTo(setWidth() * sign(slider));

    var timer;
    slider.addEventListener('scroll', function () {
      clearTimeout(timer);
      timer = setTimeout(recentre, 140);
    }, { passive: true });
    window.addEventListener('resize', function () {
      clearTimeout(timer);
      timer = setTimeout(recentre, 200);
    });

    hint(component, slider);
  }

  /* On touch screens a strip does not look scrollable. Once per visit, when it is well on screen, the cards
     lean a little the way the next ones come from (left in Hebrew, so the cards move right) and settle back.
     A touch on the strip before or during it cancels it. */
  function hint(component, slider) {
    if (!window.matchMedia('(hover: none)').matches) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!('IntersectionObserver' in window) || !slider.animate) return;
    try { if (sessionStorage.getItem('mk-loop-hint')) return; } catch (e) {}
    var touched = false;
    var running = [];
    function stop() {
      touched = true;
      running.forEach(function (a) { a.cancel(); });
    }
    slider.addEventListener('pointerdown', stop, { passive: true }); /* a touch scroll starts with pointerdown too */
    var io = new IntersectionObserver(function (entries) {
      if (!entries[0].isIntersecting) return;
      io.disconnect();
      setTimeout(function () {
        if (touched) return;
        try { sessionStorage.setItem('mk-loop-hint', '1'); } catch (e) {}
        var shift = 3.2 * parseFloat(getComputedStyle(document.documentElement).fontSize) * -sign(slider); /* 32px at 10px rem */
        var box = slider.getBoundingClientRect();
        Array.prototype.forEach.call(slider.children, function (item) {
          var r = item.getBoundingClientRect();
          if (r.right < box.left || r.left > box.right) return;
          running.push(item.animate([
            { transform: 'none' },
            { transform: 'translateX(' + shift + 'px)', offset: 0.4, easing: 'cubic-bezier(0.4, 0, 0.2, 1)' },
            { transform: 'none' }
          ], { duration: 1000, easing: 'cubic-bezier(0.3, 0, 0.3, 1)' }));
        });
      }, 500);
    }, { threshold: 0.6 });
    io.observe(component);
  }

  function init() {
    document.querySelectorAll('slider-component[data-mk-loop]').forEach(function (component) {
      if (customElements.get('slider-component')) setup(component);
      else customElements.whenDefined('slider-component').then(function () { setup(component); });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
